export default {
  fa: {
    translation: {
      general: {
        specialMessages: 'پیام های ویژه',
        calculator: 'ماشین حساب',
        calculating: 'محاسبه',
        daroogLatin: 'DarooG',
        peoplePanel: 'پنل مردمی',
        peoplePanelInfo: 'جستجوی سریع دارو در بین هزاران داروخانه در کشور',
        emal: 'اعمال',
        systemTitle: 'سامانه الکترونیکی داروخانه',
        systemFullTitle: 'سامانه الکترونیکی داروخانه داروگ',
        daroog: 'داروگ',
        tabadol: 'تبادل',
        special: 'متن آزمایشی داروگ',
        lang: 'زبان',
        yes: 'بله',
        no: 'خیر',
        confirm: 'تایید',
        search: 'جستجو',
        then: 'سپس',
        enter: 'اینتر',
        male: 'مرد',
        female: 'زن',
        mr: 'آقای',
        ms: 'خانم',
        action: 'کار',
        dashboard: 'داشبورد',
        records: 'سوابق',
        theme: 'تم',
        colors: 'رنگ‌ها',
        base: 'پایه',
        notification: 'اعلان',
        notifications: 'اعلان‌ها',
        home: 'خانه',
        description: 'شرح',
        active: 'فعال',
        inactive: 'غیرفعال',
        type: 'نوع',
        pleaseWait: 'لطفا صبر کنید',
        cancel: 'انصراف',
        bikhial: 'بیخیال',
        save: 'ذخیره',
        edit: 'ویرایش',
        term: 'عبارت',
        display: 'نمایش',
        and: 'و',
        displayList: 'نمایش لیست {{var}}',
        options: 'امکانات',
        expireDate: 'تاریخ انقضا',
        expire: 'انقضا',
        address: 'نشانی',
        address2: 'آدرس',
        landlinePhone: 'تلفن ثابت',
        mobile: 'همراه',
        phone: 'تلفن',
        website: 'وب سایت',
        email: 'ایمیل',
        postalCode: 'کد پستی',
        close: 'بستن',
        id: 'شناسه',
        nextLevel: 'مرحله بعد',
        prevLevel: 'مرحله قبل',
        sendExchange: 'ارسال',
        date: 'تاریخ',
        loading: 'در حال بارگذاری ... ',
        more: 'بیشتر',
        noMoreData: 'داده دیگری موجود نیست',
        name: 'نام',
        family: 'نام خانوادگی',
        nameFamily: 'نام و نام خانوادگی',
        location: 'مکان',
        filter: 'فیلتر',
        justOffer: 'فقط دارای هدیه',
        noData: 'اطلاعات موجود نیست',
        start: 'شروع',
        unknown: 'نامشخص',
        inventory: 'موجودی',
        price: 'قیمت',
        pricePerUnit: 'قیمت هر واحد',
        pishkhan: 'صفحه اصلی',
        offer: 'هدیه',
        to: 'به',
        number: 'تعداد',
        count: 'تعداد {{var}}',
        barcode: 'بارکد',
        batchNumber: 'Batch Number (بچ نامبر)',
        submit: 'ثبت',
        comment: 'شرح',
        sort: 'مرتب سازی',
        sortWith: 'مرتب سازی بر اساس ',
        filterWith: 'فیلتر بر اساس ',
        ascending: 'صعودی',
        descending: 'نزولی',
        all: 'همه',
        add: 'اضافه کردن',
        favorite: 'علاقه مندی',
        yourFavorite: 'محصولات پرمصرف شما',
        peopleSection: 'بخش مردمی',
        undefined: 'تعریف نشده',
        toman: 'تومان',
        ok: 'بستن',
        warning: 'هشدار',
        rial: 'ریال',
        unit: 'واحد',
        warrantyTo: 'گارانتی تا ',
        year: 'سال',
        month: 'ماه',
        day: 'روز',
        status: 'وضعیت',
        box: 'جعبه',
        num: 'عدد',
        accept: 'قبول',
        state: 'وضعیت',
        picture: 'تصویر',
        gender: 'جنسیت',
        download: 'دانلود',
        details: 'جزئیات',
        maritalStatus: 'تاهل',
        descriptions: 'توضیح',
        subject: 'موضوع',
        again: {
          0: 'مجدد',
        },
        gift: 'هدیه',
        defaultCurrency: 'ریال',
        noContent: 'محتوایی وجود ندارد',
        reject: 'عدم پذیرش',
        pay: 'پرداخت',
        code: 'کد تایید داروگ',
        systemy: 'سیستمی',
        version: 'نسخه',
        appVersion: 'نسخه نرم افزار',
        print: 'چاپ',
        category: 'دسته بندی',
        noOne: 'هیچ کدام',
        new: 'جدید',
        dr: 'دکتر',
        view: 'مشاهده',
        call: 'تماس',
        callNo: 'شماره تماس',
        daroogPhoneNumber: '02191016361',
        minimum: 'کمترین',
        maximum: 'بیشترین',
        nearest: 'نزدیکترین',
        farthest: 'دورترین',
        primitive: 'اولیه',
        nextMessage: 'پیام بعدی',
        daroogComission: 'پورسانت داروگ',
        from: 'از',
        till: 'تا',
        resetForm: 'بازنشانی فرم',
        or: 'یا',
        inNumber: 'به عدد',
        basedOnDescriptions: 'بر اساس توضیحات بالا',
        rowsPerPage: 'ردیف در صفحه',
        update: 'بروزرسانی',
        lastUpdate: 'آخرین بروزرسانی',
        createDate: 'تاریخ ثبت',
        rankingMapTitle: 'رتبه‌بندی استانی',
        rankingMapSubtitle:
          'با کلیک بر روی هر استان، داروخانه‌های برتر آن استان را مشاهده خواهید کرد.',
        rankingDropdownSubtitle:
          'با انتخاب هر استان، داروخانه‌های برتر آن استان را مشاهده خواهید کرد.',
        startDate: 'تاریخ شروع',
        endDate: 'تاریخ پایان',
        title: 'عنوان',
        removeDate: 'تاریخ حذف',
        brand: 'برند',
        logo: 'لوگو',
        slides: 'اسلایدها',
      },
      comment: {
        commentList: 'لیست نظرات',
        id: 'شناسه',
        forPharmacyName: 'برای داروخانه',
        byPharmacyName: 'توسط داروخانه',
        byUserID: 'شناسه کاربر',
        comment: 'نظر',
        star: 'امتیاز',
        sendDate: 'تاریخ ارسال',
        okAdmin: 'تاییدادمین',
        okDate: 'تاریخ آخرین تأیید',
      },

      pack: {
        pack: 'پک',
        name: 'نام پک',
        title: 'عنوان پک',
        list: 'لیست پک ها',
        create: 'ایجاد پک',
        add: 'افزودن دارو به این پک',
        category: 'دسته بندی پک',
        addDrug: 'اضافه کردن دارو',
        submitMyPacks: 'ثبت پک های من',
        submitPacks: 'ثبت پک ',
        notifications: 'اعلان ها',
        status: 'وضعیت',
      },
      date: {
        minDateAsMonth: 'حداقل تاریخ به ماه',
        minDateAsDay: 'حداقل تاریخ به روز',
        shamsi: 'شمسی',
        gregorian: 'میلادی',
        date: 'تاریخ',
        wrongDate: 'تاریخ اشتباه است',
        afterToday: 'تاریخ باید از امروز به بعد انتخاب شود',
        sendDate: 'تاریخ ارسال',
        recieveDate: 'تاریخ دریافت',
        minimumDate: 'تاریخ انتخابی باید حداقل برای {{day}} روز آینده باشد',
        registerDate: 'تاریخ ثبت',
        fromDate: 'از تاریخ',
        toDate: 'تا تاریخ',
      },
      province: {
        selectCounty: 'انتخاب استان',
        selectProvince: 'انتخاب شهر',
        selectCity: 'انتخاب شهر',
        province: 'شهرستان',
        county: 'استان',
      },
      action: {
        insert: 'درج',
        edit: 'ویرایش',
        delete: 'حذف',
        create: 'ایجاد',
        register: 'ثبت',
        activation: 'فعال کردن',
        deactivation: 'غیرفعال کردن',
        save: 'ذخیره',
        impersonate: 'ورود به جای ',
        impersonateThisPharmacy: 'ورود به جای این داروخانه',
        cancleExchange: 'لغو تبادل',
        changeStatus: 'تغییر وضعیت',
      },
      error: {
        'you-are-lost': 'احتمالا اشتباهی اومدین اینجا!',
        'page-not-found': 'صفحه‌ای که به دنبال آن هستید، پیدا نشد.',
        'error-500-line': 'مشکل؟! ما مشکل نداریم! 🤔',
        'error-500-sub': 'صفحه‌ای که به دنبال آن هستید، موقتا در دسترس نیست.',
        'fill-requireds': 'لطفا مقادیر لازم را وارد کنید.',
        'loading-data': 'خطایی در دریافت اطلاعات به وجود آمد.',
        save: 'خطایی در ذخیره اطلاعات رخ داد.',
        saveFile: 'خطایی در ذخیره فایل(ها) رخ داد',
        remove: 'خطایی در حذف اطلاعات پیش آمد.',
        network: 'مشکلی پیش آمده. لطفا اتصال اینترنت خود را بررسی کنید.',
        _404: 'ای بابا! اینجا کجاست؟!',
        _404_desc:
          'صفحه‌ای که به دنبالش بودید پیدا نشد. ' +
          'اگر با کلیک روی لینکی به این صفحه آمده‌اید لطفا به پشتیبانی اطلاع دهید.',
        _401: 'خطای دسترسی',
        _401_desc:
          'شما مجوز دسترسی به این صفحه را ندارید!' +
          'اگر فکر می‌کنید اشتباهی پیش آمده، لطفا با پشتیبانی تماس بگیرید.',
      },
      login: {
        login: 'ورود',
        exit: 'خروج',
        signOut: 'خروج از حساب کاربری',
        confirmSignOut: 'برای خروج اطمینان دارید؟',
        'login-sub': 'وارد حساب کاربری خود شوید',
        'forgot-password': 'رمز عبور را فراموش کرده‌اید؟',
        'sign-up': 'عضویت',
        'register-now': 'هم اکنون ثبت نام کنید!',
        register: 'ثبت نام',
        'register-sub': 'حساب کاربری خود را ایجاد کنید',
        'create-account': 'ایجاد حساب کاربری',
        username: 'نام کاربری / شماره همراه',
        password: 'گذرواژه',
        successful: 'ورود موفقیت آمیز بود. خوش آمدید!',
        failed:
          'ورود موفقیت آمیز نبود. نام کاربری و گذرواژه خود را بررسی کنید.',
        registerPharmacyWithUser: 'درخواست ایجاد داروخانه',
        getNewPassword: 'دریافت کلمه عبور جدید',
        send: 'ارسال',
        getOtp: 'دریافت کلمه عبور یک بار مصرف',
        otp: 'کد ورود به سامانه داروگ',
        sendCode: 'ارسال کد تایید',
        sendPhone: 'ارسال شماره همراه',
      },
      user: {
        role: 'نقش',
        rolesList: 'لیست نقش ها',
        roles: 'نقش‌ها',
        user: 'کاربر',
        name: 'نام کاربر',
        family: 'نام خانوادگی',
        nationalCode: 'کد ملی',
        birthDate: 'تاریخ تولد',
        'user-role': 'نقش کاربر',
        users: 'کاربران',
        profile: 'پروفایل',
        'create-new-role': 'ایجاد نقش جدید',
        'edit-role': 'ویرایش نقش',
        'cancel-edit-eole': 'انصراف ویرایش نقش',
        'users-list': 'لیست کارمندان',
        'create-user': 'ایجاد کاربر',
        'disable-user': 'غیرفعال کردن حساب کاربر',
        'enable-user': 'فعال کردن حساب کاربر',
        'edit-user': 'ویرایش کاربر',
        'remove-user': 'حذف کاربر',
        changeUserPassword: 'تغییر رمز عبور کاربر',
        passwordHelperText:
          'گذرواژه شامل حروف انگلیسی اعداد و حداقل ۸ کاراکتر باشد.',
        newPassword: 'رمز عبور جدید',
        admin: 'ادمین',
        goldUser: 'کاربر طلایی',
        silverUser: 'کاربر نقره ای',
        boronzeUser: 'کاربر برنزی',
        platiniumUser: 'کاربر پلاتینیوم',
        membershipRequest: 'تقاضای عضویت',
        membershipRequestsList: 'لیست تقاضای عضویت',
        sendDate: 'تاریخ درخواست',
        accepted: 'پذیرفته شده',
        members: 'اعضا',
        profilePicChanged: 'تصویر پروفایل با موفقیت تغییر کرد.',
        smsActive: 'دریافت پیامک فعال باشد',
        notifActive: 'دریافت اعلان‌ها فعال باشد',
        registerDate: 'تاریخ ثبت نام',
      },
      number: {
        zero: 'صفر',
      },
      drug: {
        drug: 'دارو',
        drugs: 'داروها',
        category: 'دسته‌بندی',
        categoryID: 'شناسه دسته‌بندی',
        name: 'نام دارو',
        genericName: 'نام ژنریک',
        companyName: 'نام شرکت',
        barcode: 'بارکد',
        enName: 'نام تجاری به انگلیسی',
        create: 'ایجاد دارو',
        suggest: 'پیشنهاد دارو',
        list: 'لیست دارو',
        drugSelection: 'انتخاب دارو',
        newDrug: 'داروی جدید',
        add: 'افزودن دارو',
        SuppliedDrugsList: 'محصولات ثبت شده توسط شما',
        latinName: 'نام لاتین',
        product: 'محصول',
        productName: 'نام تجاری',
        productName2: 'نام محصول',
        newProduct: 'محصول جدید',
        productsDatabase: 'دیتابیس محصولات',
        daysToExpire: 'تعداد روز باقیمانده به انقضای دارو',
        addNewProduct: 'ثبت محصول جدید',
      },
      peopleSection: {
        prescription: 'نسخه',
        drugRequest: 'درخواست دارو',
        makeupApplication: 'مشاوره دارویی',
        wallet: 'کیف پول',
        messages: 'پیام ها',
        peygiriCode: 'کد پیگیری نسخه',
        addPrescription: 'افزودن نسخه',
        addJobApplication: 'افزودن درخواست کار',
        listPrescription: 'لیست نسخه ها',
        newDrug: 'درخواست جدید',
        jobApplication: 'درخواست کار',
        listJobApplication: 'لیست درخواست های کار ثبت شده توسط شما',
        cancelDateText: 'کنسل شده در تاریخ',
        detail: 'جزییات',
        noAnswer: 'پاسخی وجود ندارد',
        gender: 'جنسیت',
        maritalStatus: 'وضعیت تاهل',
        readingPrescriptionCertificate: 'گواهی نسخه خوانی',
        gradeOfReadingPrescriptionCertificate: 'نمره مدرک نسخه خوانی',
        workExperienceYear: 'سابقه کار به ماه',
        suggestedWorkShift: 'شیفت پیشنهادی',
        pharmaceuticalSoftwareSkill: 'تسلط به نرم افزارهای دارویی',
        computerSkill: 'میزان تسلط به کامپیوتر',
        foreignLanguagesSkill: 'آشنایی با زبان خارجی',
        suggestedJobPosition: 'سمت پیشنهادی',
        education: 'میزان تحصیلات',
        hasGuarantee: 'وثیقه',
        countryDivisionCode: 'محدوده جغرافیائی',
        previousWorkplace: 'محل کار قبلی',
        previousWorkplacePhone: 'شماره تماس محل کار قبلی',
        landlinePhone: 'تلفن ثابت',
        address: 'آدرس',
        ostan: 'استان',
        city: 'شهر',
        descriptions: 'توضیحات',
        close: 'بستن',
        id: 'شماره پیگیری',
        sendDate: 'تاریخ ارسال',
        resumeDownload: 'دانلود تصویر رزومه',
        name: 'نام',
        family: 'نام خانوادگی',
        birthDate: 'تاریخ تولد',
        email: 'ایمیل',
        resumeFile: 'فایل رزومه',
        requestState: 'وضعیت درخواست',
        findJob: 'کاریابی',
      },
      message: {
        message: 'پیام',
        messagesForYou: 'پیام های دریافتی',
        messagesList: 'لیست پیام ها',
        createMessage: 'ایجاد پیام',
        profile: 'پروفایل',
        sms: 'پیامک',
        notification: 'ناتیفیکیشن',
        special: 'ویژه',
        detail: 'جزییات پیام',
        allMessages: 'سوابق کلیه پیام ها',
        daroogMessagesList: 'لیست پیام های دریافتی از  طرف داروگ',
        send: 'ارسال',
        sendMessageToThisPharmacy: 'ارسال پیام به این داروخانه',
      },
      category: {
        category: 'دسته‌بندی',
        categories: 'دسته‌بندی‌ها',
        list: 'لیست دسته‌بندی',
        'edit-category': 'ویرایش دسته بندی',
        'new-category': 'ایجاد دسته بندی',
        categoriesDatabase: 'دیتابیس دسته بندی ها',
      },
      exchange: {
        create: 'شروع {{var}} تبادل',
        start: 'شروع تبادل',
        save: 'تاریخ ایجاد تبادل',
        code: 'کد تبادل',
        message:
          'داروساز عزیز٬ ابتدا از تب ( انتخاب از لیست داروخانه مقابل ) محصولات مورد نیاز جهت تبادل را انتخاب نمایید. در صورت تمایل میتوانید از تب ( انتخاب از لیست عرضه شما ) محصولاتی را جهت تبادل به همکار پیشنهاد دهید.',
        exchange: 'تبادل',
        exchangeWith: 'تبادل محصول با',
        suggest: 'پیشنهاد تبادل',
        desktop: 'کارتابل',
        exchangeStartWith: 'شروع تبادل توسط',
        exchangeCanceledWith: 'لغو شده توسط',
        exchangeConfirmedWith: 'تایید شده توسط',
        exchangeConfirmed: 'تایید شد',
        system: 'سیستم',
        exchangeConfirmWith: 'تایید توسط',
        exchangeDeniedWith: 'رد شده توسط',
        exchangeViewedWith: 'مشاهده شده توسط',
        exchangeViewWith: 'مشاهده توسط',
        exchangeViewWithAutomaticConfermedAlert: 'به علت عدم تغییر سبد توسط',
        exchangeTree: 'درخت تبادل',
        allPharmacyDrugs: 'تمام داروهای این داروخانه',
        expirationDate: 'تاریخ انقضای تبادل',
        expirationCompletionDate: 'تاریخ تکمیل',
        GOLD: 'کاربر طلایی',
        SILVER: 'کاربر نقره‌ای',
        BRONZE: 'کاربر برنزی',
        PLATINUM: 'کاربر پلاتینوم',
        amount: 'مبلغ تبادل',
        totalAmountA: 'جمع مبلغ طرف اول',
        totalAmountB: 'جمع مبلغ طرف دوم',
        finalAmount: 'مبلغ قابل پرداخت',
        selectedAmount: 'مبلغ انتخابی',
        commission: 'مبلغ پورسانت',
        commissionA: 'پورسانت طرف اول',
        commissionB: 'پورسانت طرف دوم',
        paymentStatus: 'وضعیت پرداخت',
        payed: 'پرداخت شده',
        notPayed: 'پرداخت نشده',
        supplyList: 'لیست عرضه',
        sendDate: 'تاریخ شروع تبادل',
        completionDate: 'تاریخ تکمیل تبادل',
        state: 'وضعیت',
        totalPrice: 'مجموع قیمت',
        totalCount: 'تعداد کل',
        basketTotalPrice: 'مجموع قیمت سبد',
        myProducts: 'محصولات من',
        products: 'محصولات',
        exCalculator: 'لیست تبادل',
        you: 'شما',
        otherSide: 'طرف مقابل',
        threePercentWarning:
          'اختلاف مبلغ سبد شما و سبد طرف مقابل بیش از ۳ درصد است.',
        difference: 'اختلاف قیمت',
        continue: 'ادامه تبادل',
        exchangeManagement: 'مدیریت تبادل',
        viewExchange: 'مشاهده تبادل',
        widget: 'ابزارک تبادل',
        waitingForYourConfirmation: 'تبادل‌های در انتظار',
        exchangesWithFavorites: 'سبدهای شامل علاقمندی',
        searchDrugPlaceHolder: 'عبارت را وارد کرده و سپس کلید اینتر را بزنید',
        groupDrugCategorySearchPlaceholder: 'نام یا کد دارو را وارد کنید',
        fromYours: 'از سبد شما',
        fromOthers: 'از سبد طرف مقابل',
        selectFromYourCart: 'انتخاب دارو از سبد خود',
        aiSuggestion: 'انتخاب توسط هوش مصنوعی',
        selectMyself: 'خودم انتخاب می‌کنم',
        confirmToSelectFromOwnCart:
          'آیا تمایل دارید از لیست داروهای خود، اقلامی را انتخاب نمایید؟',
        displayType: 'نحوه نمایش',
        showCardsWithoutFilter: 'نمایش کارت‌ها بدون فیلتر',
        showAllItems: 'نمایش تمام اقلام',
        pharmacyItemsCount: 'تعداد کل اقلام این داروخانه',
        showExpiredToo: 'نمایش داروهای منقضی شده',
      },
      favorite: {
        addToDrugList: 'اضافه کردن دارو به لیست علاقه مندی',
        addToCategoryList: 'اضافه کردن دسته بندی به لیست علاقه مندی',
        faves: 'علاقمندی‌ها',
        neededItems: 'اقلام مورد نیاز',
        all: 'همه علاقمندی‌ها',
        noOtherFaves: 'این داروخانه، علاقمندی ثبت نکرده است.',
        force: 'نیاز اضطراری',
        yourFave: 'مورد علاقه شما',
      },
      alert: {
        attention: 'توجه',
        confirm: 'باشه',
        cancel: 'بی خیال',
        disableTextAlert: 'آیا می خواهید غیرفعال شود؟',
        enableTextAlert: 'آیا میخواهید فعال شود؟',
        successfulDisableTextMessage: 'با موفقیت غیرفعال شد',
        successfulEnableTextMessage: 'با موفقیت فعال شد',
        successfulRemoveTextMessage: 'با موفقیت حذف شد',
        successfulCreateTextMessage: 'با موفقیت ایجاد شد',
        successfulEditTextMessage: 'با موفقیت به روزرسانی شد',
        successfulSave: 'با موفقیت ذخیره شد',
        successfulDelete: 'با موفقیت حذف شد.',
        successAddDrug: 'داروی مورد نظر با موفقیت ثبت شد',
        successAddPack: 'بسته مورد نظر با موفقیت ثبت شد',
        removeAddDrug: 'داروی مورد نظر با موفقیت حذف شد',
        send: 'عملیات ارسال با موفقیت انجام شد',
        removeAddPack: 'بسته مورد نظر با موفقیت حذف شد',
        remove: 'آیا از حذف مطمئن هستید؟',
        failedEdit: 'ویرایش با خطا روبرو شد',
        fillFormCarefully: 'در پر کردن مقادیر فرم بیشتر دقت کنید.',
        failedRemove: 'حذف با خطا روبرو شد',
        errorUserNamePassword: 'نام کاربری یا کلمه عبور اشتباه است',
        failed: 'عملیات با خطا مواجه شد!',
        done: 'با موفقیت انجام شد.',
        cancelConfirm: 'آیا از لغو این مورد مطمئن هستید؟',
        aiSuggestion:
          'آیا به هوش مصنوعی داروگ اجازه پیشنهاد از سبد خودتان را می‌دهید؟',
        removeExchange: 'آیا از حذف تبادل اطمینان دارید؟',
        impersonate: 'آیا می‌خواهید به جای این داروخانه وارد شوید؟',
        unsuccessful: 'عملیات ناموفق',
        successfulMessageSent: 'پیام با موفقیت ارسال شد.',
        errorMessageNotSent: 'متاسفانه در ارسال پیام مشکلی پیش آمد',
        commentConfirmationStatus: 'آیا مایل به تغییر وضعیت نظر کاربر هستید؟',
      },
      pharmacy: {
        pharmacy: 'داروخانه',
        pharmacies: 'داروخانه‌ها',
        pharmacyId: 'شناسه',
        ID: 'شناسه داروخانه',
        topList: 'لیست داروخانه های برتر',
        create: 'ایجاد داروخانه',
        list: 'لیست داروخانه‌ها',
        new: 'داروخانه جدید',
        name: 'نام داروخانه',
        hix: 'HIX',
        star: 'تعداد ستاره',
        province: 'استان',
        city: 'شهر',
        gli: 'GLN',
        type: 'نوع داروخانه',
        governmental: 'داروخانه دولتی',
        nonGovernmental: 'داروخانه غیردولتی',
        workTime: 'ساعت کار',
        request: 'درخواست ایجاد',
        manager: 'مدیر داروخانه',
        addToTransferList: 'افزودن محصول',
        favoriteList: 'لیست علاقه مندی ها',
        memberRole: 'انتساب نقش‌ها',
        x: 'طول جغرافیایی',
        y: 'عرض جغرافیایی',
        xLong: 'طول جغرافیایی',
        yLat: 'عرض جغرافیایی',
        long: 'طول جغرافیایی',
        lat: 'عرض جغرافیایی',
        location: 'مکان',
        chooseLocationOnMap: 'انتخاب مکان روی نقشه',
        searchPharmacy: 'جستجوی داروخانه',
        sideA: 'طرف اول',
        sideB: 'طرف دوم',
        productsUpdateDate: 'تاریخ ثبت',
        itemsCount: 'تعداد اقلام',
        finalScore: 'امتیاز نهایی',
        userType: 'رتبه',
        code: 'کد معرف',
        profile: 'پروفایل داروخانه',
      },
      PharmacyTypeEnum: {
        NonGovernmental: 'خصوصی',
        Governmental: 'دولتی',
        Hospital: 'بیمارستانی',
        Military: 'نظامی',
        Test: 'تست داروگ',
      },
      WorkTimeEnum: {
        PartTime: 'نیمه وقت',
        FullTime: 'تمام وقت',
        Nightly: 'شبانه‌روزی',
      },
      UserTypeEnum: {
        GOLD: 'کاربر طلایی',
        SILVER: 'کاربر نقره‌ای',
        BRONZE: 'کاربر برنزی',
        PLATINUM: 'کاربر پلاتینوم(ابتدایی)',
      },
      CategoryTypeEnum: {
        MEDICAL: 'پزشکی',
        MAKEUP: 'آرایشی بهداشتی',
      },
      PackStatusEnum: {
        ArzeShodeh: 'عرضه شده',
        ForookhtehShodeh: 'فروخته شده',
        Deleted: 'حذف شده',
      },
      // PrescriptionCostTypesEnum: {
      //   Free: 'رایگان',
      //   Normal: 'عادی',
      //   Special: 'خاص',
      //   Vip: 'ویژه',
      // },
      ExchangeStateEnum: {
        // 0
        UNKNOWN: 'نامشخص',
        // 1
        NOSEND: 'ارسال نشده',
        // 2
        WAITFORB: 'منتظر تائید طرف دوم',
        // 3
        CONFIRMB_AND_WAITFORA: 'منتظر تائید طرف اول',
        // 4
        CONFIRMA_AND_B: 'تائید هر دو طرف و منتظر پرداخت',
        // 5
        NOCONFIRMB: 'مخالفت توسط طرف دوم',
        // 6
        CONFIRMB_AND_NOCONFIRMA: 'مخالفت توسط طرف اول',
        // 7
        CANCELLED: 'لغو شده',
        // 8 -  'تائید طرفین و در انتظار پرداخت طرف مقابل'
        CONFIRMA_AND_B_PAYMENTA: 'تبادل کامل شده',
        // 9
        CONFIRMA_AND_B_PAYMENTB: 'در انتظار پرداخت (طرف اول هستید)',
        // 10
        CONFIRMALL_AND_PAYMENTALL: 'تائید و پرداخت هر دو طرف',
        // 11
        NOSEND_FORB: 'ارسال نشده',
        // 12
        WAITFORB_FORB: 'منتظر تائید شما',
        // 13
        CONFIRMB_AND_WAITFORA_FORB: 'منتظر تائید نهایی داروخانه مقابل',
        // 14
        CONFIRMA_AND_B_FORB: 'تائید شده و در انتظار پرداخت',
        // 15
        NOCONFIRMB_FORB: 'رد شده توسط شما',
        // 16
        CONFIRMB_AND_NOCONFIRMA_FORB: 'مخالفت شده توسط داروخانه مقابل',
        // 17
        CANCELLED_FORB: 'لغو شده',
        // 18
        CONFIRMA_AND_B_PAYMENTA_FORB: 'در انتظار پرداخت (طرف دوم هستید)',
        // 19 - 'تائید طرفین و در انتظار پرداخت طرف مقابل',
        CONFIRMA_AND_B_PAYMENTB_FORB: 'تبادل انجام شده',
        // 20
        CONFIRMALL_AND_PAYMENTALL_FORB: 'تبادل کامل شده',
      },
      CancellerEnum: {
        PHARMACYA_NOTRESPONSE: '- عدم پاسخگوئی داروخانه طرف اول',
        PHARMACYB_NOTRESPONSE: 'عدم پاسخگوئی داروخانه طرف دوم',
        BYSUPPORUSER: 'لغو توسط پشتیبانی',
        PHARMACYA_AFTERSEND: 'پشیمان شدن داروخانه طرف اول',
      },
      accounting: {
        billing: 'خرید اشتراک',
        accounting: 'مالی',
        amount: 'مبلغ',
        list: 'لیست تراکنش‌های مالی',
        transactions: 'تراکنش‌ها',
        accountingForPayment: 'صورتحساب',
        addTransaction: 'افزودن تراکنش مالی',
        areYouSure: 'آیا از ثبت این تراکنش مطمئن هستید؟',
        creditor: 'بستانکار',
        debtor: 'بدهکار',
        enterAmount: 'مبلغ را وارد کنید.',
        code: 'کد تراکنش',
        exchangeAmount: 'مبلغ تراکنش',
        payLater: 'بعدا پرداخت می‌کنم',
        payment: 'پرداخت',
        history: 'تاریخچه خریدها',
      },
      reports: {
        report: 'گزارش',
        reports: 'گزارش‌ها',
        others: 'سایر گزارش‌ها',
        accounting: 'گزارش‌های مالی',
        drugs: 'گزارش محصولات',
        public: 'گزارش‌های مردمی',
        SurplusDrugsForm: 'گزارش داروهای مازاد',
        FavoriteDrugsForm: 'داروهای مورد علاقه داروخانه‌ها',
        SelectedDrugsForm: 'گزارش داروهای انتخاب شده در تبادل',
        loginCount: 'گزارش تعداد لاگین‌ها',
        loginCountTitle: 'تعداد لاگین‌ها',
        basedOn: 'بر اساس',
        allPharmacyDrug: 'محصولات داروخانه‌ها',
        acceptedPrescriptions: 'نسخه‌های پذیرفته شده',
        allPrescriptions: 'تمام نسخه‌ها',
        allEmploymentApplicationsReport: 'درخواست‌های کاریابی',
        yourPharmacyStats: 'آمار داروخانه شما',
        allPharmaciesStats: 'آمار داروخانه‌های کل کشور',
        allExchangesChart: 'نمودار وضعیت تبادلات در کشور',
        allAccounting: 'تراکنش‌های مالی',
        allAccountingFull: 'تمام تراکنش‌های مالی',
        allPharmacyWithSurplusDrugs: 'قیمت و تعداد محصولات داروخانه‌ها',
        getAllSubscribes: 'لیست تمام اشتراک‌ها',
        allPacks: 'پک‌ها',
        pharmacyDrugHistory: 'سوابق محصولات',
        relatedPharmacyDrug: 'لیست داروخانه‌ها بر اساس علاقمندی',
      },
      countryDivision: {
        province: 'استان',
        city: 'شهر',
        name: 'محدوده جغرافیایی',
      },
      jobSearch: {
        jobSearch: 'کاریابی',
        downloadResume: 'دانلود رزومه',
      },
      prescription: {
        prescription: 'نسخه',
        peoplePrescription: 'نسخه مردمی',
        peoplePrescriptions: 'نسخه‌های مردمی',
        sendDate: 'تاریخ ارسال نسخه',
        cancelDate: 'تاریخ لغو',
        responseDate: 'تاریخ پاسخ',
        response: 'پاسخ به نسخه',
        cantEdit:
          'امکان ویرایش این نسخه وجود ندارد. نسخه کنسل شده یا تاریخ آن گذشته است.',
        comment: 'شرح نسخه',
        pharmacyComment: 'توضیح داروخانه',
        reject: 'رد نسخه',
        accept: 'تایید نسخه',
      },
      PrescriptionResponseStateEnum: {
        NotAccept: 'پذیرفته نشد',
        Accept: 'پذیرفته شد',
        Tahvil: 'تحویل بیمار شد',
        NoTahvil: 'تحویل بیمار نشد',
        Waiting: 'منتظر پاسخ شما',
      },
      employment: {
        application: 'درخواست کاریابی',
        applications: 'درخواست‌های کاریابی',
        workExperience: 'سابقه کار به ماه',
        resume: 'رزومه',
        readingPrescriptionCertificate: 'گواهی نسخه خوانی',
        gradeOfReadingPrescriptionCertificate: 'نمره مدرک نسخه خوانی',
        suggestedWorkShift: 'شیفت پیشنهادی',
        pharmaceuticalSoftwareSkill: 'تسلط به نرم‌افزارهای دارویی',
        computerSkill: 'میزان تسلط به کامپیوتر',
        foreignLanguagesSkill: 'آشنایی با زبان های خارجی',
        education: 'میزان تحصیلات',
        suggestedJobPosition: 'سمت پیشنهادی',
        guarantee: 'وثیقه',
        previousWorkplace: 'محل کار قبلی',
        previousWorkplacePhone: 'تلفن محل کار قبلی',
      },
      settings: {
        settings: 'تنظیمات',
        general: 'تنظیمات عمومی',
        password: 'کلمه عبور',
        currentPassword: 'کلمه عبور فعلی',
        repeatPassword: 'تکرار کلمه عبور {{var}}',
        newPassword: 'کلمه عبور جدید',
        passwordMinLength: 'حداقل طول مجاز رمز عبور',
        passwordRequiredLetter: 'استفاده از حروف در رمز عبور اجباری است',
        passwordRequiredSymbol: 'استفاده از علائم در رمز عبور اجباری است',
        ticketExireDuration: 'مدت اعتبار رمزیکبار مصرف به دقیقه',

        exchange: 'تبادل',
        diffrenceAllowPercentageInExchange:
          'درصد مجاز اختلاف مجموع مبالغ اقلام هر طرف در تبادل',
        exchangeDeadline: 'مهلت تائید یک تبادل به ساعت',
        debtAmountAllow: 'مبلغ مجاز بدهکاری',
        debtTimeAllow: 'مدت مجازی بدهکاری به ساعت',
        surveyTime: 'چند ساعت بعد از تبادل موفق برای طرفین نظرسنجی ارسال شود',
        drugExpireDay: 'حداقل مدت اعتبار دارو به روز',

        message: 'پیام',
        messageExpireDayDefault: 'مدت انقضای پیام به روز',
        smsNumber: 'شماره خط پیامک',
        smsAPIkey: 'کلید سامانه پیامک',
        notificationAPIkey: 'کلید سامانه ارسال اعلان‌ها',
        notificationSenderkey: 'کلید ارسال کننده اعلان‌ها',
        applicationUrl: 'آدرس سایت',
        mapAPIkey: 'کلید ای پی آی نقشه',
        prescriptionCost1: 'هزینه نسخه عادی (ریال)',
        prescriptionCost2: 'هزینه نسخه صدرنشین (ریال)',
        prescriptionCost3: 'هزینه نسخه پشتیبان (ریال)',
        jobRequestCost: 'هزینه درخواست کاریابی (ریال)',
        prescriptionDiscountWhenUsePharmacyCode:
          'تخفیف کاربر پس از ورود کد معرف در نسخه (ریال)',
        prescriptionPursantWhenUsePharmacyCode:
          'پورسانت داروخانه پس از ورود کد معرف در نسخه (ریال)',
        payments: 'پرداخت ها',
      },
      settingsAi: {
        settingsAi: 'تنظیمات سیستم توصیه گر',
        id: 'شناسه',
        _date: 'تاریخ',
        pharmacyDrugScore: 'ضریب امتیاز نهایی',
        pharmacyDrugIsFavorite: 'داروهای مورد علاقه',
        pharmacyDrugIsCategoryFavorite: 'دسته دارویی مورد علاقه',
        pharmacyDrugSearchCount: 'جستجوی دارو',
        pharmacyDrugAddToBasketCount: 'افزودن دارو به سبد تبادل',
        pharmacyDrugOpenListCount: 'باز شدن لیست عرضه',
        pharmacyDrugIsSimilarFavorite: 'داروی مشابه در لیست علاقمندی',
        pharmacyDrugExchangeBasketCount: 'داروی تبادل شده',
        pharmacyDrugRemoveFromExchangeBasketCount: 'حذف دارو از سبد تبادل',
        pharmacyDrugCanceledExchangeBasketCount: 'لغو تبادل به دلیل دارو',
        drugScore: 'ضریب امتیاز نهایی',
        drugAdditionalCount: 'تعداد حضور در لیست عرضه',
        drugFavoriteCount: 'تعداد حضور در لیست علاقمندی',
        drugSearchCount: 'تعداد جستجوی دارو',
        drugExchangeCount: 'تعداد تبادل دارو',
        pharmacyPharmacyScore: 'ضریب امتیاز نهایی',
        pharmacyPharmacyAvgScore: 'متوسط امتیاز داروخانه‌ها بهم',
        pharmacyPharmacyExchangeCount: 'تعداد تبادل موفق',
        pharmacyPharmacyCanceledExchangeCount: 'تعداد تبادل کنسل شده',
        pharmacyPharmacyOpenListCount: 'باز کردن لیست عرضه',
        pharmacyPharmacyIsSameProvince: 'هم‌استانی بودن',
        pharmacyPharmacyIsSameCity: 'هم‌شهری بودن',
        pharmacyPharmacyIsCloseDistance: 'مجاور (نزدیک) هم بودن',
        pharmacyPharmacyNeighboringDistanceMeters:
          'معیار مجاورت (فاصله برحسب متر)',
        pharmacyScore: 'ضریب امتیاز نهایی',
        pharmacyAvgScore: 'متوسط امتیاز نظرسنجی‌ها',
        pharmacyExchangeCount: 'تعداد تبادل موفق',
        pharmacyCanceledExchangeCount: 'تعداد تبادل کنسل کرده',
        pharmacySumOfExchangePrice: `ارزش تبادلات (به ازای هر یک میلیون ریال)`,
        pharmacyFavoriteCount: 'تعداد لیست علاقمندی',
        pharmacyOpenListCount: 'تعداد باز شدن لیست عرضه',
        pharmacyWarrantyAmount: 'ارزش گارانتی (به ازای هر هزار ریال)',
        pharmacyPeopleResponseCount: 'تعداد پاسخ به نسخه‌های مردمی',
        pharmacyEmployeeRequestCount: 'تعداد آگهی استخدام',
        pharmacyFillSurveyCount: 'تعداد مشارکت در نظرسنجی',
        pharmacyActionCount: 'میزان فعالیت در سامانه داروگ',
        pharmacyFillProfileInfo: 'میزان تکمیل اطلاعات پروفایل',
        pharmacyPaymentDaleyCount: 'جریمه تاخیر غیرمجاز در پرداخت',
        pharmacySelectedForceDrugsInExchange: 'تعداد انتخاب داروهای فورس',
        pharmacyForceDrugDaysCount:
          'معیار فورس شدن (تعداد روز باقیمانده تا انقضا)',
        pharmacyOfferRatio: 'میانگین هدیه داروهای لیست عرضه',
        pharmacyPriceDifAvg: 'اختلاف قیمت با میانگین دیگران',
        pharmacyExpRemainDays: 'میانه مهلت زمانی داروهای لیست عرضه',
        section1: 'ضرایب امتیازات (ارزش) شاخص‌های ارتباط بین داروخانه و دارو',
        section2: 'ضرایب امتیازات (ارزش) شاخص‌های هر قلم دارو (بصورت کلی)',
        section3:
          'ضرایب امتیازات (ارزش) شاخص‌های ارتباط داروخانه با داروخانه مقابل (اعمال امتیاز به کل لیست عرضه)',
        section4:
          'ضرایب امتیازات (ارزش) شاخص‌های داروخانه بصورت کلی (اعمال امتیاز به کل لیست عرضه)',
        section5:
          'ضرایب امتیازات (ارزش) شاخص‌های مختص به داروهای لیست عرضه یک داروخانه',
      },
      survey: {
        survey: 'نظرسنجی',
        surveyList: 'لیست نظرسنجی',
        widget: 'ابزارک نظرسنجی',
        participate: 'شرکت در نظرسنجی',
      },
      jobs: {
        jobs: 'فرصت های شغلی',
        hasReadingPrescriptionCertificate: 'توانایی نسخه خوانی',
        livingInArea: 'سکونت در محل',
        hasGuarantee: 'داشتن وثیقه',
        suggestedWorkShift: 'ساعات کار پیشنهادی',
        foreignLanguagesSkill: 'سطح زبان انگلیسی',
        jobPosition: 'موقعیت شغلی',
        list: 'لیست فرصت های شغلی',
        minWorkExperienceYear: 'حداقل سابقه کار به ماه',
        minGradeOfReadingPrescriptionCertificate: 'نمره گواهی نسخه خوانی',
        pharmaceuticalSoftwareSkill: 'توانایی کار با نرم افزار',
        computerSkill: 'توانایی کار با کامپیوتر',
        education: 'تحصیلات',
        maxAge: 'حداکثر سن',
        employment: 'استخدام',
      },
      MaritalStatusType: {
        Married: 'متاهل',
        Single: 'مجرد',
      },
      GenderType: {
        Male: 'مرد',
        Female: 'زن',
        None: 'فرقی نمی کند',
      },
      StateType: {
        NoMatter: 'مهم نیست',
        Have: 'داشته باشد',
        NoHave: 'نداشته باشد',
      },
      WorkShiftType: {
        Morning: 'صبح',
        Evening: 'عصر',
        MorningEvening: 'صبح و عصر',
        Night: 'شب',
        Free: 'تایم آزاد',
      },
      SkillLevel: {
        Novice: 'ابتدایی',
        Intermediate: 'متوسط',
        Expert: 'حرفه‌ای',
      },

      JobPositionType: {
        MasoolFani: 'مسئول فنی',
        GhaemMagham: 'قائم مقام',
        OperatorNoskhe: 'اپراتور نسخه',
        NoskhePich: 'نسخه پیچ',
        Hesabdar: 'حسابدار',
        ForooshandeArayeshi: 'فروشنده آرایشی بهداشتی',
        Anbardar: 'انباردار',
        NirooSade: 'نیروی ساده',
        Karamooz: 'کارآموز',
        ForooshandeMokamel: 'فروشنده مکمل',
        Other: 'سایر',
      },

      EducationLevel: {
        NoEducation: 'بی‌سواد',
        HighSchool: 'سیکل',
        DiplomaDegree: 'دیپلم',
        TechnicianDegree: 'فوق دیپلم',
        BachelorDegree: 'لیسانس',
        MasterDegree: 'فوق لیسانس',
        DoctoralDegree: 'دکترا',
      },

      fda: {
        fda: 'سازمان غذا و دارو',
        exchanges: 'تبادلات',
      },

      alerts: {
        CreatePackAlert:
          'داروساز شما میتوانید محصولات موجود در یک تا سه دسته بندی را به صورت پک ثبت نمایید. در تبادل پک ها، داروخانه مقابل حق انتخاب دارو و تعداد را ندارد و موظف است کل اقلام پک را با تعداد ثبت شده انتخاب نماید.',
        supplylistsAlert: 'نام محصول را به صورت فارسی یا انگلیسی جستجو نمایید.',
        step1SearchAlert:
          'می‌توانید به صورت همزمان چندین محصول را جستجو نمایید.',
        ExchangeAlertPart1: 'داروساز عزیز٬ ابتدا از تب ( ',
        ExchangeAlertPart2: 'انتخاب از لیست داروخانه مقابل ',
        ExchangeAlertPart3:
          ') محصولات مورد نیاز جهت تبادل را انتخاب نمایید. در صورت تمایل میتوانید از تب ( ',
        ExchangeAlertPart4: 'انتخاب از لیست عرضه شما ',
        ExchangeAlertPart5: ') محصولاتی را جهت تبادل به همکار پیشنهاد دهید. ',
        ExchangeAlertPart6:
          'اطلاعات زیر شما را در انجام راحت‌تر تبادل کمک می‌کند.',
        FavoritesAlert:
          'داروساز عزیز٬ با ثبت داروها یا دسته بندی های دارویی مورد علاقه خود به هوش مصنوعی داروگ کمک می کنید تا بهترین لیست ها را منطبق با علایقتان برای داشتن تبادلی آسان تر و مطلوب تر شما نمایش بدهد.',
        PrescriptionAlert:
          'نام محصول مورد نیاز خود را درج، یا تصویر نسخه را بارگذاری کنید.\nداروخانه‌های سراسر کشور یا محدوده درخواستی شما، در صورت موجودی به شما اطلاع خواهند داد.\nاطلاع‌رسانی از طریق پیامک، یا مشاهده در نرم افزار و سایت داروگ امکان‌پذیر است.',
        SelectCategoryAlert: 'ابتدا دسته بندی را انتخاب نمایید',
        DebotAlert:
          'بدهی شما بیشتر از سقف مجاز می باشد و امکان تبادل مقدور نیست.  لطفا نسبت به تسویه و پرداخت بدهی اقدام نمایید',
        lockedEchangeAlert:
          'تبادل توسط طرف مقابل قفل شده است. شما تنها میتوانید این تبادل را قبول یا رد کنید و نمیتوانید محصولات موجود در سبدها را ویرایش نمایید',
        offerDescriptions: 'هدیه به داروساز مقابل',
        priceTypeAlert:
          'در داروگ قیمت ها بر اساس کوچکترین واحد هر محصول محاسبه میشود. به عنوان مثال ۱ عدد قرص استامینوفن. جهت انجام محاسبات لازم میتوانید از دکمه محاسبه استفاده نمایید',
        reloadModalToEnterNewDrug:
          'این صفحه بعد از افزودن محصول٬ جهت افزودن محصول جدید باز بماند',
        searchProduct:
          'برای جستجو حداقل سه کارکتر از نام یا نام ژنریک و یا نام انگلیسی محصول را وارد نمایید',
        cantEditProfile:
          'از آنجا که ویرایش اطلاعات داروخانه توسط شما مقدور نمی باشد٬ در صورت نیاز میتوانید با پشتیبانی تماس بگیرید',
        offerAlertFirstPart: 'طبق اعداد وارد شده، شما باید ',
        offerAlertSecondPart:
          ' عدد از این محصول را به داروخانه مقابل تحویل دهید.',
        chooseCloserDateAlert: 'پورسانت بر مبنای تاریخ انقضا محاسبه میشود',
        useAi:
          'به هوش مصنوعی داروگ اجازه دهید بر اساس قیمت محصولات انتخابی شما و سلیقه داروساز مقابل، تبادل را پیش ببرد. ضمنا شما می‌توانید پس از این انتخاب نیز سبد خود را ویرایش نمایید.',
        useAi2:
          'ضمنا شما میتوانید پس از این انتخاب نیز سبد خود را ویرایش نمایید و همیشه آیکن  ',
        useAi3:
          '  در هر حالتی از انتخاب داروها برای چینش نهایی به کمک شما خواهد آمد',
        findJobAlert:
          'در این بخش میتوانید از میان فرصت های شغلی ارائه شده توسط داروخانه ها با بررسی جزئیات٬ موارد مد نظرتان را انتخاب کنید و با آن داروخانه ها جهت هماهنگی های لازم تماس بگیرید.',
        countAlert:
          'در نظر داشته باشید که تعداد را بر اساس کوچکترین واحد وارد نمایید. مثلا برای ثبت یک ورق استامینوفن باید عدد ۱۰ را وارد نمایید. یا مثلا برای یک جعبه ۱۰ ورقی از استامینوفن عدد ۱۰۰ را وارد نمایید. جهت انجام محاسبات لازم میتوانید از دکمه محاسبه استفاده نمایید',
        attentionForSupplyList:
          'لطفا به منظور بهبود جایگاه داروخانه در نتایج جستجوها، لیست محصولات خود را بروزرسانی نمایید.',
        confirmAttentionForSupplyList: 'آیا محصولات شما نیاز به ویرایش دارد؟',
        invalid: 'مقدار وارد شده معتبر نمی‌باشد',
      },

      widget: {
        Exchange: 'تبادل در انتظار',
        Survey: 'نظرسنجی',
        EmploymentApplication: 'درخواست کاریابی',
        Prescription: 'نسخه مردمی',
        FavoriteListCount: 'پیشنهاد به شما',
        startExchange: 'شروع تبادل',
        insertProduct: 'ثبت محصول',
        insertPack: 'ثبت پک',
        desktop: 'سوابق',
        insertFavorite: 'ثبت مصرفی',
      },
      speedDial: {
        startExchange: 'شروع تبادل',
        insertProduct: 'ثبت محصول',
        medicineSubmission: 'ثبت داروهای مازاد/موردنیاز',
        insertPack: 'ثبت پک',
        desktop: 'سوابق',
      },
      file: {
        file: 'فایل',
        docs: 'اسناد',
        pharmacyDocs: 'اسناد داروخانه',
        fileName: 'نام فایل',
        fileType: 'نوع فایل',
        add: 'افزودن',
        addToPharmacy: 'افزودن فایل به داروخانه',
        type: {
          nationalCard: 'کارت ملی',
          establishLicense: 'مجوز تاسیس',
          healThMinistryLicense: 'کارت نظام پزشکی',
          ctoLicense: 'پروانه مسؤول فنی ویژه داروخانه‌های دولتی',
          commitment: 'تعهدنامه ویژه داروخانه‌های بیمارستانی و دولتی',
        },
        noFileSelected: 'فایلی انتخاب نشده است',
        get: 'انتخاب فایل',
        save: 'ذخیره',
        delete: 'حذف',
        downloadCommitmentSample: 'دانلود فایل نمونه تعهدنامه',
        commitmentGuide:
          'لطفا فایل نمونه را برای تعهدنامه دانلود نموده و تصویر آن را پس از پر کردن فرم ارسال فرمایید.',
        state: {
          None: 'در دست بررسی',
          Confirmed: 'تایید',
          UnConfirmed: 'عدم تایید',
        },
      },
      findJob: {
        minGradeOfReadingPrescriptionCertificate:
          'حداقل نمره نسخه خوانی قابل قبول',
        minWorkExperienceYear: 'حداقل سابقه کار',
        maxAge: 'حداکثر سن',
        descriptions: 'توضیحات',
        hasReadingPrescriptionCertificateStr: 'توانایی نسخه خوانی',
        livingInAreaStr: 'سکونت در محل',
        hasGuaranteeStr: 'نیاز به وثیقه',
        genderStr: 'جنسیت',
        suggestedWorkShiftStr: 'شبفت کاری پیشنهادی',
        maritalStatusStr: 'وضعیت تاهل',
        pharmaceuticalSoftwareSkillStr:
          'توانایی کار با نرم افزارهای داروخانه ای',
        computerSkillStr: 'توانایی کار با کامپیوتر',
        foreignLanguagesSkillStr: 'سطح زبان انگلیسی',
        jobPositionStr: 'موقعیت شغلی مورد نیاز',
        educationStr: 'حداقل سطح تحصیلات',
      },
      commision: {
        settingsCommisions: 'تنظیمات پورسانت ها',
        list: 'لیست پورسانت ها',
        remainedExpirationDays: 'روزهای باقیمانده تا انقضا',
        commissionPercent: 'درصد پورسانت',
      },
      about: {
        about: 'درباره ما',
        story: 'داستان داروگ',
        services: 'خدمات داروگ',
        honors: 'افتخارات داروگ',
        permits: 'مجوزهای داروگ',
        cyber: 'فضای مجازی',
        update: 'بروزرسانی',
        alreadyUpdated: 'شما از آخرین نسخه استفاده می‌کنید.',
        permitLetter: 'نامه سرپرست معاونت تحقیقات و فناوری',
        enamad: 'نماد اعتماد الکترونیکی',
        address:
          'تهران، میدان هفت تیر، خ کریم خان زند، خ خردمند جنوبی، خ آذرشهر، پلاک ۳، طبقه ۶، واحد ۱۱۲',
      },
      declaration: {
        declaration: 'اعلان',
        declarations: 'اعلان‌ها',
        subject: 'موضوع',
        message: 'پیام',
        sort: 'ترتیب',
      },
      StatusType: {
        Active: 'فعال',
        Inactive: 'غیرفعال',
      },
      SubscriptionType: {
        Normal: 'عادی',
        OneTime: 'یک بار مصرف',
      },
    },
  },
}
